"use client";

import React from "react";

//type
import { ListColorItemProps } from "@/types";

//Styles
import * as S from "./styles";

const ListColorItem: React.FC<ListColorItemProps> = ({
  className,
  pendingOrders,
  finishedCommands,
  ordersCustomer,
  dict,
}) => {
  return (
    <S.List className={className}>
      <S.ListItem>
        <S.BoxColor /> {pendingOrders} {dict["pending orders"]}
      </S.ListItem>
      <S.ListItem>
        <S.BoxColor /> {finishedCommands} {dict["finished commands"]}
      </S.ListItem>
      <S.ListItem>
        <S.BoxColor /> {ordersCustomer} {dict["orders with missing client"]}
      </S.ListItem>
    </S.List>
  );
};

export default ListColorItem;
